export const onCurrency = (number, prefix = 'Rp', region) =>
  `${prefix} ${
    number !== undefined && isNaN(number) === false
      ? new Intl.NumberFormat('id-ID', {
          style: 'decimal',
          currency: 'IDR'
        }).format(number)
      : '-'
  }`
